import { render, staticRenderFns } from "./CartedProductsIndex.vue?vue&type=template&id=e7b2f2de&"
import script from "./CartedProductsIndex.vue?vue&type=script&lang=js&"
export * from "./CartedProductsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports